/* unplugin-vue-components disabled */import script from "./search_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./search_copy.vue?vue&type=script&setup=true&lang=js"

import "./search_copy.vue?vue&type=style&index=0&id=78827d36&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78827d36"]])

export default __exports__